<script setup>
import { useI18n } from 'vue-i18n';
import { useAssistantSettings } from './useAssistantSettings';
import PageLayout from 'dashboard/components-next/captain/PageLayout.vue';
import SettingsHeader from 'dashboard/components-next/captain/pageComponents/settings/SettingsHeader.vue';
import AssistantScheduleForm from 'dashboard/components-next/captain/pageComponents/assistant/settings/AssistantScheduleForm.vue';

const { t } = useI18n();
const { assistant, backUrl, isFetching, updateAssistant } =
  useAssistantSettings();
</script>

<template>
  <PageLayout
    :header-title="t('CAPTAIN.ASSISTANTS.SETTINGS.SCHEDULE.TITLE')"
    :is-fetching="isFetching"
    :back-url="backUrl"
    :show-know-more="false"
    :show-pagination-footer="false"
    :show-assistant-switcher="false"
  >
    <template #body>
      <div class="flex flex-col w-full max-w-[45rem] gap-6 pb-8">
        <SettingsHeader
          :heading="t('CAPTAIN.ASSISTANTS.SETTINGS.SCHEDULE.TITLE')"
          :description="t('CAPTAIN.ASSISTANTS.SETTINGS.SCHEDULE.DESCRIPTION')"
        />
        <AssistantScheduleForm
          :assistant="assistant"
          @submit="updateAssistant"
        />
      </div>
    </template>
  </PageLayout>
</template>
